import gen from "@/views/ticket/components/agent/utils";
import i18n from "@/i18n";
const config = gen({
    name: "AgentGroupSimple",
    data() {
        return {
            options: []
        };
    },
    async query() {
        let options = [];
        this.cascaderOptions = [];
        const { list: groupList } = await this.listAgentGroup();
        options = groupList.map(one => {
            const { id, name } = one;
            return { label: name, value: id };
        });
        options.unshift({ label: i18n.t("ticket.component.agentGroup.all"), value: null });
        this.options = options;
    }
});
export default config;
